import {ADD_TO_CART, RECEIVE_PRODUCTS, REMOVE_FROM_CART} from "../contents/actionTypes";


const products = (state = {} , action) => {

    switch (action.type)
    {
        case RECEIVE_PRODUCTS:
            return {
                ...state ,
                ...action.products.reduce((obj , product) => {
                    obj[product.id] = {...product , qty : !isNaN(product.qty) || product.qty !== undefined ? product.qty : 0}
                    return obj
                } , {})
            }

        case REMOVE_FROM_CART:
        {
            let { productId } = action
            let product = state[productId]
            let qty = product.qty - 1
            if (qty < 0)
                qty = 0
            return {
                ...state ,
                [productId] : {
                    ...product ,
                    qty :qty
                }
            }
        }

        case ADD_TO_CART:
        {
            let { productId } = action
            let product = state[productId]

            let orderInPreOrder = localStorage.getItem("orderInPreOrder") !== null && localStorage.getItem("orderInPreOrder") == 'true'
            if ( Boolean(product.available) === true || orderInPreOrder)
            {
                let qty = product.qty + 1
                if (Boolean(product.daily_stock_count_sens_status) === true && !orderInPreOrder)
                {
                    if (parseInt(product.daily_stock_count) < qty)
                    {
                        qty = parseInt(product.daily_stock_count)
                    }
                }
                if (qty > 0)
                {
                    return {
                        ...state ,
                        [productId] : {
                            ...product ,
                            qty : qty
                        }
                    }
                }
            }

            return state
        }

        default:
            return state
    }
}

export default products;